<template>
  <div class="coupon-wrap">
    <dl class="clearfix">
      <dt class="input-wrap">
        <el-input placeholder="请输入兑换码" v-model="couponId"></el-input>
      </dt>
      <dd class="button-wrap">
        <el-button @click="handleAddCoupon" :disabled="!couponId.length">添加</el-button>
      </dd>
    </dl>
    <el-tabs v-model="couponStatusId">
      <el-tab-pane :label="'未使用('+unUsedList.length+')'" name="1"></el-tab-pane>
      <el-tab-pane :label="'已使用('+UsedList.length+')'" name="2"></el-tab-pane>
      <el-tab-pane :label="'已过期('+expiredList.length+')'" name="3"></el-tab-pane>
    </el-tabs>
    <div class="coupon-list" v-if="currentCouponList.length">
      <couponItem
        class="coupon-item"
        v-for="(item, index) in currentCouponList"
        :key="index"
        :class="{'is-expired': +item.status === 3}"
        :coupon="item"></couponItem>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { addByCode } from '@/apis/base';
import couponStore from '@/core/coupon/store';
import couponItem from '@/core/coupon/coupon.vue';
import { Input, Button, Tabs, TabPane, Form, Message } from 'element-ui';

export default {
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Form.name]: Form,
    couponItem
  },
  data () {
    return {
      couponId: '',
      couponStatusId: '1'
    };
  },
  computed: {
    ...mapState({
      userCouponList: state => state.coupon.userCouponList
    }),
    currentCouponList () {
      return this.userCouponList.filter(item => +item.status === +this.couponStatusId);
    },
    unUsedList () {
      return this.userCouponList.filter(item => +item.status === 1);
    },
    UsedList () {
      return this.userCouponList.filter(item => +item.status === 2);
    },
    expiredList () {
      return this.userCouponList.filter(item => +item.status === 3);
    }
  },
  registerModule (store, preserveState) {
    store.registerModule('coupon', couponStore, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('coupon');
  },
  methods: {
    handleAddCoupon () {
      addByCode({ couponCode: this.couponId }).then(res => {
        if (res._errCode === '0') {
          Message({
            message: '添加成功',
            type: 'success'
          });
          this.couponId = '';
          this.$store.dispatch('coupon/getUserCouponList');
        } else {
          Message({
            message: res._errStr,
            type: 'error'
          });
        }
      });
    }
  },
  mounted () {
    this.$store.dispatch('coupon/getUserCouponList');
  }
};
</script>

<style scoped>
.input-wrap {
  float: left;
  width: 300px;
}

.button-wrap {
  float: left;
  margin-left: 20px;
}

.coupon-wrap {
  /deep/ .coupon-item {
    margin-left: 0px;
  }
}

.is-expired {
  opacity: .5;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/coupon/index.vue